import { Component, OnInit } from "@angular/core";
import { Router, NavigationStart } from "@angular/router";
import { TranslationService } from "app/services/translation.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
})
export class NavigationComponent implements OnInit {
  public menu_open: boolean = false;
  public i18n;

  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private translation_service: TranslationService
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) this.menu_open = false;
      })
    );

    this.subscriptions.push(
      this.translation_service.current_dictionary_observable.subscribe(
        (dictionary) => {
          this.i18n = dictionary;
        }
      )
    );
    this.i18n = this.translation_service.getDictionary();
  }

  ngOnDestroy() {
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  changeLang(new_lang) {
    this.translation_service.setLanguage(new_lang);
  }
}
